declare function require(module: string): any;
declare const process: { env: { PARTNER: string } };

import { add as hasAdd } from '@dojo/framework/core/has';

const { tiers, flags } = require(`../partners/${process.env.PARTNER}`);

const resolved: Record<string, boolean> = Object.fromEntries(
	Object.entries(tiers as Record<string, RegExp>).map(([key, regex]: [string, RegExp]) => [
		key,
		regex.test(window.location.pathname)
	])
);

(flags(resolved) as [string, boolean][]).forEach(([key, val]: [string, boolean]) => hasAdd(key, val));
